import React from 'react';

import {
  CircularProgress,
  Typography,
  Box,
  Container,
  Paper
} from '@mui/material';
import { useI18n } from '@/hooks/useI18n';

interface LoadingSpinnerProps {
  text?: string;
  fullPage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ text = 'Loading...', fullPage = false }) => {
  const { t } = useI18n();

  const spinnerContent = (
    <Box sx={{ textAlign: 'center', py: 12 }}>
      <CircularProgress size={48} sx={{ mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        {text}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('common.pleaseWait')}
      </Typography>
    </Box>
  );

  if (fullPage) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        {spinnerContent}
      </Box>
    );
  }

  return (
    <Container maxWidth="md" disableGutters>
      <Paper>
        {spinnerContent}
      </Paper>
    </Container>
  );
};

export default LoadingSpinner;
